import { useEffect, useRef, useState } from 'react';
import { SITE_FRAME_SANDBOX } from '../../../lib/html-doc-frame';
import { RECORDER_EXCLUDE_CLASS } from '../../../lib/recorder-mask';
import { inlineFrameLayout, scrollbarGutter } from '../chat-surface/MessageRow/InlineHtmlPreview';
import styles from './DocViewerModal.module.css';

const DESKTOP_WIDTH = 980;
const PHONE_WIDTH = 375;

export function sitePageNaturalWidth(url: string): number {
  try {
    return new URL(url).searchParams.get('showMobileView') === 'true' ? PHONE_WIDTH : DESKTOP_WIDTH;
  } catch {
    return DESKTOP_WIDTH;
  }
}

export function SitePageDocView({ url, title }: { url: string; title: string }) {
  const box = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState({ width: 0, height: 0 });
  const [gutter, setGutter] = useState(0);
  useEffect(() => setGutter(scrollbarGutter()), []);
  useEffect(() => {
    const element = box.current;
    if (!element || typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(([entry]) => setSize({ width: entry.contentRect.width, height: entry.contentRect.height }));
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  const { frameWidth, scale } = inlineFrameLayout(sitePageNaturalWidth(url), size.width, gutter);
  const fitted = size.width > 0 && scale < 1;
  return (
    <div ref={box} className={styles.siteBox} data-testid="sitePageDocView">
      <iframe
        title={title}
        className={`${styles.frame} ${RECORDER_EXCLUDE_CLASS}`}
        src={url}
        sandbox={SITE_FRAME_SANDBOX}
        referrerPolicy="no-referrer"
        style={fitted ? { width: frameWidth, height: size.height / scale, transform: `scale(${scale})`, transformOrigin: '0 0', flex: 'none' } : undefined}
      />
    </div>
  );
}
